const messages = {
  home: {
    en: 'Support Home',
    es: 'Inicio de Soporte'
  },
  guides: {
    en: 'Troubleshooting Guides',
    es: 'Guías de Solución de Problemas'
  },
  faqs: {
    en: 'FAQs',
    es: 'FAQ'
  },
  tutorials: {
    en: 'Interactive Tutorials',
    es: 'Tutoriales Interactivos'
  },
  start: {
    en: 'Getting Started',
    es: 'Empezar'
  },
  search: {
    en: 'Search',
    es: 'Buscar'
  },
  notes: {
    en: 'Notes',
    es: 'Notas'
  },
  login: {
    en: 'Login',
    es: 'Iniciar Sesión'
  }
}

export default messages
